/**
 * Shop the range — grid-slider arrow fixes.
 * 1) goToSlide: clamp so last card stops on 1320 container edge.
 * 2) Arrow click: step by one card width (theme sibling logic breaks when
 *    a left-bleeding card stays is-visible / prev has no previousElementSibling).
 */
(function () {
  function getInset(slider) {
    const raw = getComputedStyle(slider).getPropertyValue('--shop-range-inset').trim();
    const px = parseFloat(raw);
    return Number.isFinite(px) ? px : 0;
  }

  function getStep(slider) {
    const slide = slider.querySelector('[data-grid-item]');
    if (!slide) return 0;
    const gap = parseInt(window.getComputedStyle(slide).marginRight, 10) || 0;
    return slide.offsetWidth + gap;
  }

  function maxScroll(slider) {
    return Math.max(0, slider.scrollWidth - slider.clientWidth);
  }

  function isShopRange(el) {
    return Boolean(el?.closest?.('.index-tab-collections--shop-the-range'));
  }

  function patch() {
    const Ctor = customElements.get('grid-slider');
    if (!Ctor || Ctor.prototype.__shopRangeArrowsPatched) return;

    const originalGoTo = Ctor.prototype.goToSlide;
    const originalClick = Ctor.prototype.buttonArrowClickEvent;

    if (typeof originalGoTo === 'function') {
      Ctor.prototype.goToSlide = function (slide) {
        if (!slide || !this.slider || !isShopRange(this)) {
          return originalGoTo.call(this, slide);
        }

        const inset = getInset(this.slider);
        const target = Math.min(Math.max(0, slide.offsetLeft - inset), maxScroll(this.slider));

        this.slider.scrollTo({
          top: 0,
          left: target,
          behavior: 'smooth',
        });
      };
    }

    if (typeof originalClick === 'function') {
      Ctor.prototype.buttonArrowClickEvent = function (e) {
        if (!isShopRange(this) || !this.slider) {
          return originalClick.call(this, e);
        }

        e.preventDefault();
        e.stopPropagation();

        const btn = e.target.closest('[data-button-arrow]');
        if (!btn || btn.disabled) return;

        const step = getStep(this.slider);
        if (!step) return;

        let target = this.slider.scrollLeft;
        if (btn.hasAttribute('data-button-prev')) {
          target = Math.max(0, this.slider.scrollLeft - step);
        } else if (btn.hasAttribute('data-button-next')) {
          target = Math.min(maxScroll(this.slider), this.slider.scrollLeft + step);
        }

        this.slider.scrollTo({
          top: 0,
          left: target,
          behavior: 'smooth',
        });
      };
    }

    Ctor.prototype.__shopRangeArrowsPatched = true;
  }

  function init() {
    if (customElements.get('grid-slider')) {
      patch();
      return;
    }
    customElements.whenDefined('grid-slider').then(patch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
